import BackgroundRotator from './BackgroundRotator'

const homeImages = [
  "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/5.jpg",
  "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/6.jpg",
  "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/7.jpg",
  "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/8.jpg",
  "https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/9.jpg",
  'https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/4.jpg',
  'https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/3.jpg',
  'https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/2.jpg',
  'https://d3rnpbgh9zefuh.cloudfront.net/Photography/Analog/Thermal/1.jpg'
]

export default function Home() {
  return (
    <main className="home-fullscreen">
      <BackgroundRotator images={homeImages} durationMs={1800} fadeMs={0.1} scale={0.8}/>
    </main>
  )
}
